import { axInstBasic } from "../Service/Service";

export const fetchPsfSalesAllYearData = async (parArn, childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}psf_sales_chart`, {parArn, childArn}
    );
    return res.data.result || []; 
  } catch (error) {
    console.error("Error fetching fleet ID:", error);
    throw error;
  }
};

export const fetchPsfSalesMonthData = async (parArn, childArn, selectedYear) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}psfSalesMonthChart`, {parArn, childArn, selectedYear}
    );
    return res.data.result || []; 
  } catch (error) {
    console.error("Error fetching fleet ID:", error);
    throw error;
  }
};

export const fetchPsfSalesCesAllYearsData = async (parArn, childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}ces_sales_chart`, {parArn, childArn}
    );
    return res.data.result || []; 
  } catch (error) {
    console.error("Error fetching fleet ID:", error);
    throw error;
  }
};

export const fetchPsfSalesCesMonths = async (parArn, childArn, selectedYear) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}cesSalesMonthChart`, {parArn, childArn, selectedYear}
    );
    return res.data.result || []; 
  } catch (error) {
    console.error("Error fetching fleet ID:", error);
    throw error;
  }
};

export const fetchPsfSalesDssatAllYears = async (parArn, childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}dssat_sales_chart`, {parArn, childArn}
    );
    return res.data.result || []; 
  } catch (error) {
    console.error("Error fetching fleet ID:", error);
    throw error;
  }
};

export const fetchPsfSalesDssatMonthData = async (parArn, childArn, selectedYear) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}dssatSalesMonthChart`, {parArn, childArn, selectedYear}
    );
    return res.data.result || []; 
  } catch (error) {
    console.error("Error fetching fleet ID:", error);
    throw error;
  }
};

export const fetchPsfServiceScoreAllYearData = async (parArn, childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}psf_service_chart`, {parArn, childArn}
    );
    return res.data.result || []; 
  } catch (error) {
    console.error("Error fetching fleet ID:", error);
    throw error;
  }
};

export const fetchPsfServiceScoreMonthData = async (parArn, childArn, selectedYear) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}psfServiceMonthChart`, {parArn, childArn, selectedYear}
    );
    return res.data.result || []; 
  } catch (error) {
    console.error("Error fetching fleet ID:", error);
    throw error;
  }
};

export const fetchPsfServiceCesAllYears = async (parArn, childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}ces_service_chart`, {parArn, childArn}
    );
    return res.data.result || []; 
  } catch (error) {
    console.error("Error fetching fleet ID:", error);
    throw error;
  }
};

export const fetchPsfServiceCesMonths = async (parArn, childArn, selectedYear) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}cesServiceMonthChart`, {parArn, childArn, selectedYear}
    );
    return res.data.result || []; 
  } catch (error) {
    console.error("Error fetching fleet ID:", error);
    throw error;
  }
};


export const fetchPsfServiceDssatAllYears = async (parArn, childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}dssat_service_chart`, {parArn, childArn}
    );
    return res.data.result || []; 
  } catch (error) {
    console.error("Error fetching fleet ID:", error);
    throw error;
  }
};

export const fetchPsfServiceDssatMonths = async (parArn, childArn, selectedYear) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}dssatServiceMonthChart`, {parArn, childArn, selectedYear}
    );
    return res.data.result || []; 
  } catch (error) {
    console.error("Error fetching fleet ID:", error);
    throw error;
  }
};

export const fetchPsfSalesData = async (parArn, childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}psf_sales`, {parArn, childArn}
    );
    return res.data.result || []; 
  } catch (error) {
    console.error("Error fetching fleet ID:", error);
    throw error;
  }
};

export const fetchPsfServiceData = async (parArn, childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}psf_service`, {parArn, childArn}
    );
    return res.data.result || []; 
  } catch (error) {
    console.error("Error fetching fleet ID:", error);
    throw error;
  }
};









